import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type {
  ZuubManualCheckRequest,
  ZuubManualCheckResponse,
} from '@/@types/zuub/contracts';

import { makeAPIRequestReactQueryWithHeaders } from '../api';
import { endpoints } from '../endpoints';

/**
 * Mutation to submit a manual benefits check for a new patient (RCM Zuub).
 * Sends Practice and Org headers. Returns a requestId to track the check.
 */
export const useZuubManualCheck = () => {
  const {
    primaryPracticeId: practiceId,
    primaryOrganizationId: organizationId,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  return useMutation<ZuubManualCheckResponse, Error, ZuubManualCheckRequest>(
    (data) =>
      makeAPIRequestReactQueryWithHeaders<ZuubManualCheckResponse>(
        endpoints.zuubManualCheck,
        {},
        {
          Org: organizationId,
          Practice: practiceId,
        },
        'POST',
        {
          data,
        },
      ),
  );
};
